import { computed } from "vue";
import type { Table } from "@tanstack/vue-table";

export const useRowsIndexPointer = <T>(table: Table<T>) => {
  const rowsIndexPointer = computed(() => {
    const allRowsCount = table.getPaginationRowModel().rows.length;
    const { pageIndex, pageSize } = table.getState().pagination;
    const startIndex = allRowsCount > 0 ? pageIndex * pageSize + 1 : 0;
    const endIndex = pageIndex * pageSize + allRowsCount;

    return {
      startIndex,
      endIndex,
    };
  });

  return rowsIndexPointer;
};
